import DashboardIcon from "@mui/icons-material/Dashboard";
import { Button, Grid, Typography } from "@mui/material";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
  defaults,
} from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import LoadingWrapper from "../loading";
import ChartProvider from "./index";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin
);

const BarChartStackedCustom = ({
  title,
  xAxis = "x",
  xAxisTitle = "",
  yAxisTitle = "",
  data = [],
  series = [],
  colors = [],
  loading = false,
  interval = 1,
  showBrush = false,
  stackId = 1,
  showZoomOutButton = false,
  className = "",
  customTooltips = [],
  yAxisMax = null,
  yAxisMin = null,
}) => {
  defaults.font.family = "dana FD";

  const [state, setState] = useState({
    chart: { labels: [], datasets: [] },
  });

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const labels = data.map((item) => item[xAxis]);

      const datasets = series.map((sere, index) => ({
        label: sere,
        data: data.map((item) => item[sere]),
        borderColor: ChartProvider.renderColor(colors, index), // Set borderColor to custom color
        backgroundColor: ChartProvider.renderColor(colors, index), // Set backgroundColor to custom color
      }));

      setState((old) => ({
        ...old,
        chart: {
          labels,
          datasets,
        },
      }));
    }
  }, [data]);

  const onRenderFooter = (tooltipItems) => {
    // console.log("tooltipItems", tooltipItems);
    if (tooltipItems?.length) {
      const { dataIndex } = tooltipItems[0];
      // debugger;
      if (customTooltips?.[dataIndex]) {
        return customTooltips[dataIndex];
      }
    }
    return "";
  };

  const scales = {
    x: {
      type: "category",
      stacked: stackId ? true : false,
      grid: {
        borderColor: "rgba(0, 0, 1)",
        color: "rgba(0, 0, 0, 0.1)",
      },
      title: {
        display: true,
        text: xAxisTitle,
      },
    },
    y: {
      type: "linear",
      stacked: stackId ? true : false,
      ticks: {
        callback: (val, index, ticks) =>
          index === 0 || index === ticks.length - 1 ? null : val,
      },
      grid: {
        borderColor: "rgba(0, 0, 1)",
        color: "rgba(0, 0, 0, 0.1)",
      },
      title: {
        display: true,
        text: yAxisTitle,
        fontSize: 5,
      },
      ...(typeof yAxisMin === "number" ? { min: yAxisMin } : {}),
      ...(typeof yAxisMax === "number" ? { max: yAxisMax } : {}),
    },
  };

  const options = {
    responsive: true,
    scales: scales,
    interaction: {
      mode: "index",
      intersect: false,
    },
    stacked: false,
    plugins: {
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
          modifierKey: "ctrl",
        },
        zoom: {
          drag: {
            enabled: true,
          },
          wheel: {
            enabled: true,
            modifierKey: "ctrl",
          },
          mode: "x",
        },
      },
      ...(customTooltips?.length
        ? {
            tooltip: {
              callbacks: {
                footer: onRenderFooter,
              },
            },
          }
        : {}),
    },
  };

  return (
    <Grid
      container
      style={{ direction: "ltr", minHeight: 250 }}
      className={clsx(className)}
    >
      {loading ? (
        <Grid
          item
          xs={12}
          md={12}
          container
          justifyContent="center"
          alignItems="center"
        >
          <LoadingWrapper />
        </Grid>
      ) : Array.isArray(data) && data.length > 0 ? (
        <Grid item xs={12} md={12} style={{ position: "relative" }}>
          {/* <Typography textAlign={"center"} variant="h6" fontWeight={"bold"}>
            {title}
          </Typography> */}

          {showZoomOutButton && (
            <Button
              onClick={() => {
                setState((old) => ({ ...old, chart: { ...old.chart } }));
              }}
              variant="outlined"
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                fontSize: 8,
              }}
            >
              Zoom Out
            </Button>
          )}

          <Bar options={options} data={state.chart} />
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          md={12}
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <DashboardIcon sx={{ fontSize: "8rem", mb: 3 }} color="gray" />
          <Typography color="gray" variant="h6" fontWeight="bold">
            داده ای جهت نمایش وجود ندارد
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default BarChartStackedCustom;
